 /**
  * File: questionDirective.js
  * Project: educore
  * Created Date: 2019--01-23
  * Author: Raziya S
  * Screen : 
  */
 class QuestionDirective {
     // @ngInject
     constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $timeout, $interval) {


         let authoring = localStorageService.get("authoringData")
         if (authoring === undefined)
             $state.go('dashboard')
         $scope.score = 0
         let qpId = $state.params.qpId
         $scope.minutes = []
         for (var min = 5; min <= 20; min += 5) {
             $scope.minutes.push(min);
         }
         $scope.class = authoring.class
         let userId = localStorageService.get('user_id')
         let schoolId = authoring.school_id
         let activityId = $state.params.activityId
         if (authoring === undefined)
             $state.go('dashboard')
         let subjectId = ''
         localStorage.setItem('authoringData', JSON.stringify(authoring));
         localStorage.removeItem("is_restart");
         $scope.fullScreen = false;
         $scope.totalQuestion = [];
         $scope.questions = [];
         $scope.attendedQuesObj = [];
         $scope.selectedAns = [];
         $scope.questionCollection = [];
         $scope.imageData = [];
         $scope.ansFib = [];
         $scope.ansOwq = [];
         $scope.ansSa = [];
         $scope.ansLa = [];
         $scope.ansDraw = [];
         $scope.ansAslListen = [];
         $scope.ansAslSpeak = [];
         $scope.loadQuestionDirective = false;
         $scope.isOptionSelected = false;
         $scope.actionBtnName = 'Submit';
         $scope.errorFib = {};
         $scope.errorOwq = {};
         $scope.errorMtf = {};
         $scope.errorMrQues = {};
         $scope.errorMcqQues = {};
         $scope.errorTFQues = {};
         $scope.totalQuestiontoShow = 0;
         $scope.indexToShow = 0;
         $scope.quizTotalMark = 0;
         $scope.noOfAttempts = 0;
         $scope.elapsedTime = 0
         $scope.remainingTime = ''
         $scope.score = 0;
         // questionPaperId = '';
         $scope.isPracticeTest = false;
         $scope.timeData = "";
         $scope.haveNoPassword = true;
         $scope.accessbility = true;
         $scope.isActivity = true
         $scope.selectedCheckAns = [];
         $scope.multipleCheckAnsData = [];

         let totalMark = 0

         let endTime = undefined

         //Meteor.subscribe('questionPaper')

         let tempQuestions = [];
         let currentDay = '';
         let questionPaperData = {};

         var startTime = 0,
             currentTime = null,
             offset = 0,
             interval = null,
             // self = this;
             options = {}
         if (!options.interval) {
             options.interval = 100;
         }
         localStorage.setItem('activityId', activityId)
         localStorage.setItem('backfromexam', true)
         options.elapsedTime = new Date(0);
         $scope.running = false;
         this.$onDestroy = () => {
             //submitAnsEachQuestion(false, true);
             submitAnsEachQuestion(false, false);

             clearTimer()
             toastr.success("Your answer is submitted successfully")
             $mdDialog.cancel()
         }

         this.$onInit = function() {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
             let requestObj = {}
             requestObj["activity_id"] = activityId
             requestObj["qp_id"] = qpId
             requestObj["student_id"] = userId
             let academics = _.pick(authoring, 'curriculum_id', 'session_id', 'class_id', 'subject_id', 'batch_id', 'school_id', 'academic_year');
             requestObj = _.extend(requestObj, academics)
             authService.callAPI(activityCons.API_GET_EXAM_QUESTIONS, "POST", requestObj, function(response) {
                 if (response) {
                     if (response.result.status && response.result.status.code == 200) {
                         loadQuestions(response.result)
                     } else {
                         toastr.error(response.result.data.message)
                         $state.go('activityFormPreview', {
                             resourceId: activityId
                         }, {
                             reload: true
                         })
                     }

                 } else {
                     console.log("error : " + response.error)
                     if (response.error.status && response.error.status.message) {
                         toastr.error(response.error.status.message)
                     }
                     if (response.error.data && response.error.data.message) {
                         toastr.error(response.error.data.message)
                     }
                     if (response.error.error && response.error.error.status) {
                         toastr.error(response.error.error.status)
                     }
                 }
             })
         }

         let initilaizeTimer = (timeObj) => {
             let deadline;
             $scope.remainingTime = ''
             if (parseInt(timeObj.hour) == 0 && parseInt(timeObj.min) == 0) {
                 $scope.remainingTime = '00 : 00 : 00'
             } else {
                 if (parseInt(timeObj.hour) === 0) {
                     $scope.elapsedTime = (parseInt(timeObj.min) * 60 * 1000) + (parseInt(timeObj.sec) * 1000)
                 } else {
                     $scope.elapsedTime = (parseInt(timeObj.hour) * 60 * 60 * 1000) +
                         (parseInt(timeObj.min) * 60 * 1000) + (parseInt(timeObj.sec) * 1000)
                 }

                 deadline = new Date(Date.parse(new Date()) + $scope.elapsedTime);
                 $scope.initializeClock(deadline);
                 $scope.startTimer();

             }

         }

         let loadQuestions = (questionPaperData) => {
             $scope.isPracticeTest = questionPaperData.practice_qn;
             $scope.graceTime = 0;

             if (questionPaperData && questionPaperData.data && questionPaperData.data.details) {

                 let responseObj = questionPaperData.data.details
                 $scope.isPracticeTest = responseObj.practice_qn;

                 endTime = new Date(responseObj.endTime)
                 $scope.serverDate = new Date(responseObj.serverTime)
                 let timeObj = {}
                 if ($scope.serverDate.getTime() > endTime.getTime()) {
                     console.log("Time Expired...")

                     timeObj = {
                         "hour": 0,
                         "min": 0,
                         "sec": 0
                     }
                     initilaizeTimer(timeObj)
                 } else {
                     let secondsToTime = (endTime.getTime() - $scope.serverDate.getTime()) / 1000
                     timeObj = secondsToHrMin(secondsToTime)
                     initilaizeTimer(timeObj)
                 }
                 totalMark = responseObj.total_mark
                 if (responseObj.serverTime) {
                     currentDay = new Date($scope.serverDate.getFullYear(), $scope.serverDate.getMonth(), $scope.serverDate.getDate())
                 } else {
                     let today = new Date()
                     currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate())
                 }

                 let result = responseObj.questions
                 _.each(result, function(quest, key) {
                     $scope.questions.push(quest)
                     if (quest.isLatex) {
                         $scope.formatToLatex()
                     }
                     let optionAnswer = []
                     //To covert image into image array - multiple image
                     if (quest) {
                         if (quest.type === "MCQ") {
                             if (!(Array.isArray(quest.questionImg)) && quest.questionImg != null)
                                 quest.questionImg = _.flatten([quest.questionImg])
                             _.each(quest.choice, function(eachChoice) {
                                 if (!(Array.isArray(eachChoice.optImage)) && eachChoice.optImage != null)
                                     eachChoice.optImage = _.flatten([eachChoice.optImage])
                             })
                         } else if (quest.type === "FIB" || quest.type === "TF" || quest.type === "OWQ" || quest.type === "SA" || quest.type === "LA") {
                             if (!(Array.isArray(quest.questionImg)) && quest.questionImg != null)
                                 quest.questionImg = _.flatten([quest.questionImg])
                         } else if (quest.type === "IBT_FIB") {
                             if (!(Array.isArray(quest.passage_image)) && quest.questionImg != null)
                                 quest.passage_image = _.flatten([quest.passage_image])
                             if (!(Array.isArray(quest.questionImg)) && quest.questionImg != null)
                                 quest.questionImg = _.flatten([quest.questionImg])
                         } else if (quest.type === "IBT_MCQ") {
                             if (!(Array.isArray(quest.passage_image)) && quest.questionImg != null)
                                 quest.passage_image = _.flatten([quest.passage_image])
                             if (!(Array.isArray(quest.questionImg)) && quest.questionImg != null)
                                 quest.questionImg = _.flatten([quest.questionImg])
                             _.each(quest.choice, function(eachChoice) {
                                 if (!(Array.isArray(eachChoice.optImage)) && quest.questionImg != null)
                                     eachChoice.optImage = _.flatten([eachChoice.optImage])
                             })
                             if (!(Array.isArray(quest.passage_image)) && quest.questionImg != null)
                                 quest.passage_image = _.flatten([quest.passage_image])
                         } else if (quest.type === "DRAW") {
                             if (!(Array.isArray(quest.questionImg)) && quest.questionImg != null)
                                 quest.questionImg = _.flatten([quest.questionImg])
                         }
                     }

                     if (quest.type === "MTF") {
                         quest['quesData'] = [];
                         _.each(quest.option, function(eachAns) {
                             quest.quesData.push(eachAns.question)
                             optionAnswer.push(eachAns.answer)
                         })
                         optionAnswer = _.shuffle(optionAnswer)
                         quest.optionAnswer = optionAnswer
                     }

                     if (quest.type === "TF") {
                         let choices = _.shuffle(quest.choice)
                         quest.choice = choices
                     }

                     if (quest.type === "DRAW") {
                         quest.canvasId = "canvas_" + key
                         let emptyObj = {
                             'choice': ''
                         }
                         $scope.ansDraw.push(emptyObj)
                     }

                     if (quest.type === "ASLLISTEN") {
                         quest.playableQuestionUrl = $sce.trustAsResourceUrl(FILE_PREVIEW_URL + quest.audio_url);
                         let emptyAnsList = [];
                         _.each(quest.questions, function(question) {
                             let emptyObj = {
                                 _id: question._id,
                                 type: question.type
                             }
                             switch (question.type) {
                                 case 'mcq':
                                     if (question.pattern == 'single')
                                         emptyObj['answer'] = ""
                                     else
                                         emptyObj['answer'] = []
                                     break;
                                 case 'fib':
                                     emptyObj['answer'] = []
                                     break;
                                 default:
                                     emptyObj['answer'] = ""
                                     break;
                             }
                             emptyAnsList.push(emptyObj)
                         })
                         $scope.ansAslListen[key] = {
                             ans: emptyAnsList
                         };
                     }
                     if (quest.type === "ASLSPEAK") {
                         $scope.ansAslSpeak[key] = {
                             answer: ''
                         }
                     }

                     quest.submit_status = quest.q_status
                         //Display previously Submitted answer
                     if (quest.answer && quest.answer.length > 0) {


                         if (quest.type === "FIB" || quest.type === "IBT_FIB") {
                             _.each(quest.answer, function(fib_ans, c_key) {
                                 if (fib_ans) {
                                     if (!$scope.ansFib) {
                                         $scope.ansFib = []
                                     }

                                     let choiceObj = {
                                         "choice": {}
                                     }
                                     choiceObj["choice"][c_key] = fib_ans
                                     $scope.ansFib.splice(key, 0, choiceObj);
                                 }
                             })
                             $scope.imageData[key] = quest.answerImg
                         } else if (quest.type === "MCQ" || quest.type === "IBT_MCQ") {

                             if (!$scope.multipleCheckAnsData) {
                                 $scope.multipleCheckAnsData = []
                             }
                             //$scope.multipleCheckAnsData.splice(key, 0, quest.answer);
                             $scope.multipleCheckAnsData[key] = quest.answer
                         } else if (quest.type === "OWQ") {
                             if (!$scope.ansOwq) {
                                 $scope.ansOwq = []
                             }
                             $scope.ansOwq[key] = quest.answer[0]
                             $scope.imageData[key] = quest.answerImg
                         } else if (quest.type === "MTF") {
                             _.each(quest.optionAnswer, (opt, o_key) => {
                                 opt["desc"] = quest.answer[o_key].desc
                             })
                         } else if (quest.type === "TF") {
                             if (!$scope.selectedAns) {
                                 $scope.selectedAns = []
                             }
                             //$scope.selectedAns.splice(key, 0, quest.answer[0]);
                             $scope.selectedAns[key] = quest.answer[0];
                         }
                     }

                     if (quest.type === "SA") {
                         if (!$scope.ansSa) {
                             $scope.ansSa = []
                         }
                         if (!$scope.imageData) {
                             $scope.imageData = []
                         }
                         $scope.imageData[key] = quest.answerImg
                         $scope.ansSa[key] = quest.answer
                     } else if (quest.type === "LA") {
                         if (!$scope.ansLa) {
                             $scope.ansLa = []
                         }
                         if (!$scope.imageData) {
                             $scope.imageData = []
                         }
                         $scope.imageData[key] = quest.answerImg
                         $scope.ansLa[key] = quest.answer
                     }


                     if (quest.submit_status && quest.submit_status == "submit" && quest.is_attended) {
                         status = true
                     }

                     $scope.totalQuestion.push({
                         question: quest,
                         count: key + 1,
                         isActive: false,
                         status: quest.submit_status ? quest.submit_status : 'normal',
                         label: (quest.submit_status && quest.submit_status == 'review') ? 'Unmark' : 'Mark for review'
                     })
                     if ($scope.questions[key]) {
                         $scope.attendedQuesObj[key] = {
                             questionId: $scope.questions[key]._id,
                             mark: 0,
                             timeElapsed: 0,
                             section_name: $scope.questions[key].section_name
                         }
                     }
                 })
             }
             $scope.loadQuestionDirective = true
             $scope.totalQuestiontoShow = $scope.questions.length;
         }

         function secondsToHrMin(secs) {
             var hours = Math.floor(secs / (60 * 60));

             var divisor_for_minutes = secs % (60 * 60);
             var minutes = Math.floor(divisor_for_minutes / 60);

             var divisor_for_seconds = divisor_for_minutes % 60;
             var seconds = Math.ceil(divisor_for_seconds);

             var obj = {
                 "hour": hours,
                 "min": minutes,
                 "sec": seconds
             };
             return obj;
         }

         $scope.toggleFullScreen = function(fullScreen) {
             $scope.fullScreen = !fullScreen
         }

         function clearTimer() {
             $interval.cancel(timeinterval);
             $scope.remainingTime = '00 : 00 : 00'
         }

         $scope.getTimeRemaining = function(endTime) {
             let t = Date.parse(endTime) - Date.parse(new Date());
             $scope.elapsedTimeForReset = t;
             let seconds = Math.floor((t / 1000) % 60);
             let minutes = Math.floor((t / 1000 / 60) % 60);
             let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
             let days = Math.floor(t / (1000 * 60 * 60 * 24));
             return {
                 'total': t,
                 'days': days,
                 'hours': hours,
                 'minutes': minutes,
                 'seconds': seconds
             }
         }

         let MQ = MathQuill.getInterface(2);
         $scope.formatToLatex = function() {
             $timeout(function() {
                 var questionElements = document.getElementsByClassName('question_desc')
                 _.each(questionElements, function(spanElement) {
                     MQ.StaticMath(spanElement);
                 })
             }, 1000);
         }


         let timeinterval
         $scope.initializeClock = function(endTime) {

             function updateClock() {
                 if (!$scope.isSubmitted) {
                     let t = $scope.getTimeRemaining(endTime);
                     if (t)
                         $scope.totalTimeRemaining = t.total
                     let days = t.days > 0 ? t.days + ' : ' : ''
                     $scope.remainingTime = days + ('0' + t.hours).slice(-2) + " : " + ('0' + t.minutes).slice(-2) + " : " + ('0' + t.seconds).slice(-2)
                     if ($scope.remainingTime == '00 : 00 : 00') {
                         $scope.remainingTime = '00 : 00 : 00'
                         $interval.cancel(timeinterval);
                         //Auto submission
                         //$scope.submitQuizQuestion()
                         submitAnsEachQuestion(false, true);
                     }
                 } else {
                     $interval.cancel(timeinterval);
                 }
             }

             updateClock();
             timeinterval = $interval(updateClock, 1000);
         }
         $scope.startTimer = function() {
             if ($scope.running === false) {
                 startTime = new Date().getTime();
                 interval = $interval($scope.updateTime, options.interval);
                 $scope.running = true;
             }
         };

         $scope.updateTime = function() {
             currentTime = new Date().getTime();
             var timeElapsed = offset + (currentTime - startTime);
             options.elapsedTime.setTime(timeElapsed);
         };

         $scope.config = {
             autoHideScrollbar: true,
             theme: 'minimal'
         }

         $scope.stopTimer = function() {
             if ($scope.running === false) {
                 return;
             }
             $scope.updateTime();
             offset = offset + currentTime - startTime;
             $scope.running = false;
             $scope.timeData = currentTime - startTime
         };

         //timer with timeout
         $scope.timerWithTimeout = 0;
         $scope.startTimerWithTimeout = function() {
             $scope.timerWithTimeout = 0;
             if ($scope.myTimeout) {
                 $timeout.cancel($scope.myTimeout);
             }
             $scope.onTimeout = function() {
                 $scope.timerWithTimeout++;
                 $scope.myTimeout = $timeout($scope.onTimeout, 1000);
             }
             $scope.myTimeout = $timeout($scope.onTimeout, 1000);
         };

         $scope.startTimerWithTimeout();
         $scope.resetTimerWithTimeout = function() {
             $scope.timerWithTimeout = 0;
             $timeout.cancel($scope.myTimeout);
         }

         //timer with interval
         $scope.timerWithInterval = 0;
         $scope.startTimerWithInterval = function() {
             $scope.timerWithInterval = 0;
             if ($scope.myInterval) {
                 $interval.cancel($scope.myInterval);
             }
             $scope.onInterval = function() {
                 $scope.timerWithInterval++;
             }
             $scope.myInterval = $interval($scope.onInterval, 1000);
         };

         $scope.resetTimerWithInterval = function() {
             $scope.timerWithInterval = 0;
             $interval.cancel($scope.myInterval);
         }

         /* Change question by clicking question number in left side*/
         $scope.changeQuestion = function(questCount) {
             if (questCount != $scope.indexToShow) {
                 //Change button name for next question
                 if ($scope.isPracticeTest) {
                     if ($scope.totalQuestion[questCount].accessbility === true) {
                         $scope.accessbility = true
                         $scope.disableCntrlBtn = true
                     } else {
                         if ($scope.totalQuestion.length === questCount + 1) {
                             $scope.actionBtnName = "Submit"
                         } else {
                             $scope.accessbility = false
                             $scope.disableCntrlBtn = true
                             $scope.actionBtnName = "Next"
                         }

                     }
                     if ($scope.totalQuestion[questCount].status === 'submit') {
                         $scope.resultStatus = 'Explanation'
                         var questObj = $scope.questions[questCount];
                         if (questObj.type == "MCQ") {
                             if (questObj.pattern == "single") {
                                 angular.forEach(questObj.choice, function(value, key) {
                                     if (value.correct) {
                                         $scope.ansExplanation = value.explanation;
                                     }
                                 });
                             } else {
                                 $scope.ansExplantionMR = ""
                                 angular.forEach(questObj.choice, function(value, key) {
                                     if (value.correct) {
                                         $scope.ansExplantionMR += (key + 1) + ' . ' + value.explanation;
                                     }
                                 });
                             }
                         } else if (questObj.type == "TF") {
                             angular.forEach(questObj.choice, function(value, key) {
                                 if (value.correct) {
                                     $scope.ansExplanation = value.explanation;
                                 }
                             });
                         } else if (questObj.type == "FIB") {
                             $scope.ansExplantionFIB = ""
                             angular.forEach(questObj.answer, function(value, key) {
                                 if (value.desc != undefined) {
                                     $scope.ansExplantionFIB += (key + 1) + ' . ' + value.explanation
                                 }
                             })
                         } else if (questObj.type == "OWQ") {
                             $scope.ansExplantionOWQ = ""
                             angular.forEach(questObj.answer, function(value, key) {
                                 if (value.desc != undefined) {
                                     $scope.ansExplantionOWQ += (key + 1) + ' . ' + value.explanation
                                 }
                             })
                         } else if (questObj.type == "MTF") {
                             //for (var i = 0; i < $scope.quesData.length; i++) {
                             var optionsObj = questObj.option;
                             $scope.ansExplantionMTF = ''
                             var index = 0
                             _.each(optionsObj, function(option) {
                                 index += 1
                                 let explanation = option.explanation === undefined ? 'NA' : option.explanation
                                 if (index === 1) {
                                     $scope.ansExplantionMTF += index + ' . ' + explanation
                                 } else {
                                     $scope.ansExplantionMTF += ' , ' + index + ' . ' + explanation
                                 }
                             })
                         }
                         $scope.isOptionSelected = true
                     } else {
                         $scope.isOptionSelected = false
                     }

                 } else {
                     $scope.evaluateQuizQuestion($scope.indexToShow);
                     //To send details of each question. if student attend
                     submitAnsEachQuestion(false, false);
                 }
                 $scope.indexToShow = questCount;
                 if (!$scope.isPracticeTest) {
                     $scope.startTimer()
                 }
             }
         }

         /* Invoke while clicking review option*/

         $scope.reviewQuestion = function() {
             if ($scope.totalQuestion[$scope.indexToShow].label == "Mark for review") {
                 $scope.totalQuestion[$scope.indexToShow].status = 'review'
                 $scope.totalQuestion[$scope.indexToShow].label = 'Unmark'
             } else {
                 $scope.totalQuestion[$scope.indexToShow].status = 'normal'
                 $scope.totalQuestion[$scope.indexToShow].label = 'Mark for review'
             }
         }


         /* Practice Test Starts*/

         let marks = {
             'student_id': userId,
             'type': 'PracticeTest',
             'date': currentDay,
             'result': [],
             "subject_id": authoring.subject_id,
             "session_id": authoring.session_id,
             "curriculum_id": authoring.curriculum_id,
             "batch_id": authoring.batch_id,
             "class_id": authoring.class_id,
             "theme_id": $scope.selectedThemeId,
             'activity_id': activityId,
             'qp_id': qpId,
         }

         let scoreDetails = []
             /* Submitting practice test questions*/
         $scope.submitQuestion = function() {
             if (!$scope.isOptionSelected) {
                 toastr.error("Please answer the question")
                 return
             }
             if ($scope.actionBtnName == "Submit") { //|| $scope.actionBtnName == "Try Again") {
                 $scope.noOfAttempts += 1
                 var isCorrectAns = false;
                 var questObj = $scope.questions[$scope.indexToShow];
                 let mark = $scope.questionCollection[$scope.indexToShow].mark_each_qn;
                 if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                     if (questObj.pattern == "single") {
                         $scope.errorMcqQues = {}
                         angular.forEach(questObj.choice, function(value, key) {
                             if (value.correct && $scope.selectedAns[$scope.indexToShow] == value.desc) {
                                 $scope.stopTimer();
                                 if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {

                                 } else {
                                     scoreDetails[$scope.indexToShow] = {
                                         mark: parseFloat(mark)
                                     }
                                     $scope.score += parseFloat(mark);
                                 }
                                 isCorrectAns = true;
                                 $scope.answerType = "Correct Answer";
                                 $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                                 $scope.answerStatus = "correct"
                                 $scope.errorMcqQues[value.desc] = {
                                     answerType: 'Correct Answer',
                                     answerStatus: 'correct',
                                     msg: value.hint
                                 };
                                 marks.result[$scope.indexToShow] = {
                                     question_id: questObj._id,
                                     attempt_count: $scope.noOfAttempts,
                                     time_elapsed: $scope.timeData
                                 }
                             } else if ($scope.selectedAns[$scope.indexToShow] == value.desc) {
                                 $scope.answerType = "Wrong Answer";
                                 $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                                 $scope.answerStatus = "wrong"
                                 $scope.errorMcqQues[value.desc] = {
                                     answerType: 'Wrong Answer',
                                     answerStatus: 'wrong',
                                     msg: value.hint
                                 };
                             }
                         });
                     } else {
                         let wrongAnsCount = 0;
                         $scope.ansExplantionMR = ''
                         $scope.errorMrQues = {}
                         let correctAns = '';
                         let choices = [];
                         let crctObj = _.filter(questObj.choice, function(det) {
                             return det.correct === true
                         })
                         for (var i = crctObj.length - 1; i >= 0; i--) {
                             correctAns += crctObj[i].desc + "[,]"
                         }

                         _.each(questObj.choice, function(choice) {
                             choices.push({
                                 name: choice.desc,
                                 "description": {
                                     "en-US": choice.hint
                                 }
                             })
                         })

                         angular.forEach(questObj.choice, function(value, key) {
                             if (value.correct) {
                                 if ($scope.checkingChoiceExists(value.desc)) {
                                     let explanation = value.explanation === undefined ? 'NA' : value.explanation
                                     $scope.errorMrQues[value.desc] = {
                                         answerType: 'Correct Answer',
                                         answerStatus: 'correct',
                                         msg: (key + 1) + ' . ' + explanation
                                     };
                                     $scope.ansExplantionMR = key == 0 ? $scope.ansExplantionMR = (key + 1) + ' . ' + explanation : $scope.ansExplantionMR += (key + 1) + ' . ' + explanation
                                 } else {
                                     wrongAnsCount += 1;
                                     //$scope.errorMrq[value.desc] = {answerType: 'Wrong Answer', answerStatus: 'wrong', msg:(key+1)+' . '+value.hint};
                                 }
                                 $scope.stopTimer();
                             } else if ($scope.checkingChoiceExists(value.desc)) {
                                 wrongAnsCount += 1;
                                 let hint = value.hint === undefined ? 'NA' : value.hint
                                 $scope.errorMrQues[value.desc] = {
                                     answerType: 'Wrong Answer',
                                     answerStatus: 'wrong',
                                     msg: (key + 1) + ' . ' + hint
                                 };
                                 $scope.ansExplantionMR = key == 0 ? $scope.ansExplantionMR = (key + 1) + ' . ' + hint : $scope.ansExplantionMR += (key + 1) + ' . ' + hint
                             }
                         });
                         if (wrongAnsCount == 0) {
                             //$scope.score+=questObj.mark;
                             $scope.accessbility = false
                             if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {

                             } else {
                                 scoreDetails[$scope.indexToShow] = {
                                     mark: parseFloat(mark)
                                 }
                                 $scope.score += parseFloat(mark);
                             }
                             marks.result[$scope.indexToShow] = {
                                 question_id: questObj._id,
                                 attempt_count: $scope.noOfAttempts,
                                 time_elapsed: $scope.timeData
                             }
                             isCorrectAns = true;
                         }
                     }
                 } else if (questObj.type == "TF") {

                     var keepGoing = false;
                     $scope.errorTFQues = {}
                     var correctAns;
                     angular.forEach(questObj.choice, function(value, key) {
                         if (!keepGoing) {
                             if (value.correct && $scope.selectedAns[$scope.indexToShow] == value.tag) {
                                 correctAns = value.correct
                                 $scope.stopTimer();
                                 //$scope.score+=questObj.mark;
                                 if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {

                                 } else {
                                     scoreDetails[$scope.indexToShow] = {
                                         mark: parseFloat(mark)
                                     }
                                     $scope.score += parseFloat(mark);
                                 }
                                 marks.result[$scope.indexToShow] = {
                                         question_id: questObj._id,
                                         attempt_count: $scope.noOfAttempts,
                                         time_elapsed: $scope.timeData
                                     }
                                     //marks.result.push(markObj)
                                 isCorrectAns = true;
                                 $scope.accessbility = false
                                 keepGoing = true;
                                 $scope.answerType = "Correct Answer";
                                 $scope.ansExplanation = value.explanation === undefined ? 'NA' : value.explanation;
                                 $scope.answerStatus = "correct"
                                 $scope.errorTFQues[$scope.selectedAns[$scope.indexToShow]] = {
                                     answerType: 'Correct Answer',
                                     answerStatus: 'correct',
                                     msg: value.explanation
                                 };
                             } else {
                                 keepGoing = false;
                                 $scope.answerType = "Wrong Answer";
                                 $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                                 $scope.answerStatus = "wrong"
                                 $scope.errorTFQues[$scope.selectedAns[$scope.indexToShow]] = {
                                     answerType: 'Wrong Answer',
                                     answerStatus: 'wrong',
                                     msg: value.hint
                                 };
                             }
                         }
                     });

                 } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                     var fibAnswerCount = questObj.question_answer.length;
                     var wrongAnsCount = 0;
                     $scope.ansExplantionFIB = ''
                     var studentAnswer = ''
                     var correctValue = ''
                     angular.forEach(questObj.question_answer, function(value, key) {
                         if (value.desc != undefined) {
                             if ($scope.ansFib.length > 0) {
                                 if ($scope.ansFib[$scope.indexToShow].choice[key] == "" || $scope.ansFib[$scope.indexToShow].choice[key] == undefined) {
                                     wrongAnsCount += 1;
                                     $scope.stopTimer();
                                     let hint = value.explanation === undefined ? 'NA' : value.explanation
                                     $scope.errorFib[value.desc] = {
                                         answerType: 'Cant be empty',
                                         answerStatus: 'info',
                                         msg: (key + 1) + ' . ' + hint
                                     };
                                     $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = (key + 1) + ' . ' + hint : $scope.ansExplantionFIB += (key + 1) + ' . ' + hint
                                 } else {
                                     let correctValue = value.desc
                                     let studentAnswer = $scope.ansFib[$scope.indexToShow].choice[key]
                                     if (correctValue.toLowerCase().trim() == studentAnswer.toLowerCase().trim()) {
                                         let explanation = value.explanation === undefined ? 'NA' : value.explanation
                                         $scope.errorFib[value.desc] = {
                                             answerType: 'Correct Answer',
                                             answerStatus: 'correct',
                                             msg: (key + 1) + ' . ' + value.explanation
                                         };
                                         $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = (key + 1) + ' . ' + explanation : $scope.ansExplantionFIB += (key + 1) + ' . ' + explanation
                                     } else {
                                         $scope.stopTimer();
                                         let hint = value.explanation === undefined ? 'NA' : value.explanation
                                         $scope.errorFib[value.desc] = {
                                             answerType: 'Wrong Answer',
                                             answerStatus: 'wrong',
                                             msg: (key + 1) + ' . ' + hint
                                         };
                                         $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = (key + 1) + ' . ' + hint : $scope.ansExplantionFIB += (key + 1) + ' . ' + hint
                                         wrongAnsCount += 1;
                                     }
                                 }
                             } else {
                                 wrongAnsCount += 1;
                                 $scope.stopTimer();
                                 let hint = 'Cant be empty'
                                 $scope.errorFib[value.desc] = {
                                     answerType: 'Cant be empty',
                                     answerStatus: 'info',
                                     msg: (key + 1) + ' . ' + hint
                                 };
                             }
                         }
                     });

                     if (wrongAnsCount == 0) {
                         $scope.accessbility = false
                         $scope.stopTimer();
                         //$scope.score+=questObj.mark;
                         if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {

                         } else {
                             scoreDetails[$scope.indexToShow] = {
                                 mark: parseFloat(mark)
                             }
                             $scope.score += parseFloat(mark);
                         }
                         marks.result[$scope.indexToShow] = {
                             question_id: questObj._id,
                             attempt_count: $scope.noOfAttempts,
                             time_elapsed: $scope.timeData
                         }
                         isCorrectAns = true;
                     }

                 } else if (questObj.type == "OWQ") {
                     var fibAnswerCount = questObj.answer.length;
                     var wrongAnsCount = 0;
                     $scope.ansExplantionOWQ = ''
                     var correctans = undefined
                     angular.forEach(questObj.answer, function(value, key) {
                         if (value.desc != undefined) {
                             correctans = value.desc;
                             if ($scope.ansOwq.length > 0) {
                                 if ($scope.ansOwq[$scope.indexToShow] == "" || $scope.ansOwq[$scope.indexToShow] == undefined) {
                                     wrongAnsCount += 1;
                                     $scope.stopTimer();
                                     let hint = value.hint === undefined ? 'NA' : value.hint
                                     $scope.errorOwq[value.desc] = {
                                         answerType: 'Cant be empty',
                                         answerStatus: 'info',
                                         msg: (key + 1) + ' . ' + hint
                                     };
                                     $scope.ansExplantionOWQ = (key + 1) + ' . ' + hint
                                 } else {
                                     /*let correctValue = removeSpecialCharacter(value.desc)
                                     let studentValue = removeSpecialCharacter($scope.ansOwq[$scope.indexToShow])*/

                                     let correctValue = value.desc
                                     let studentValue = $scope.ansOwq[$scope.indexToShow]
                                     if (correctValue.toLowerCase().trim() == studentValue.toLowerCase().trim()) {
                                         let explanation = value.explanation === undefined ? 'NA' : value.explanation
                                         $scope.errorOwq[value.desc] = {
                                             answerType: 'Correct Answer',
                                             answerStatus: 'correct',
                                             msg: (key + 1) + ' . ' + value.explanation
                                         };
                                         $scope.ansExplantionOWQ = (key + 1) + ' . ' + explanation
                                     } else {
                                         $scope.stopTimer();
                                         let hint = value.hint === undefined ? 'NA' : value.hint
                                         $scope.errorOwq[value.desc] = {
                                             answerType: 'Wrong Answer',
                                             answerStatus: 'wrong',
                                             msg: (key + 1) + ' . ' + hint
                                         };
                                         $scope.ansExplantionOWQ = (key + 1) + ' . ' + hint
                                         wrongAnsCount += 1;
                                     }
                                 }
                             } else {
                                 wrongAnsCount += 1;
                                 $scope.stopTimer();
                                 let hint = 'Cant be empty'
                                 $scope.errorOwq[value.desc] = {
                                     answerType: 'Cant be empty',
                                     answerStatus: 'info',
                                     msg: (key + 1) + ' . ' + hint
                                 };
                             }
                         }
                     });

                     if (wrongAnsCount == 0) {
                         //babin
                         $scope.accessbility = false
                             //
                         $scope.stopTimer();
                         //$scope.score+=questObj.mark;
                         if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {

                         } else {
                             scoreDetails[$scope.indexToShow] = {
                                 mark: parseFloat(mark)
                             }
                             $scope.score += parseFloat(mark);
                         }
                         marks.result[$scope.indexToShow] = {
                             question_id: questObj._id,
                             attempt_count: $scope.noOfAttempts,
                             time_elapsed: $scope.timeData
                         }
                         isCorrectAns = true;
                     }

                 } else if (questObj.type == "MTF") {
                     $scope.ansExplantionMTF = ''
                     let wrongAnsCount = 0
                     let correctans = ''
                     let source = []
                     let target = []

                     for (var i = 0; i < questObj.option.length; i++) {
                         var optionsObj = questObj.option[i];

                         correctans += optionsObj.question.desc + "[.]" + optionsObj.answer.desc + "[,]"

                         source.push({
                             "id": optionsObj.question.desc,
                             "description": {
                                 "en-US": optionsObj.question.desc
                             }
                         })

                         target.push({
                             "id": optionsObj.answer.desc,
                             "description": {
                                 "en-US": optionsObj.answer.desc
                             }
                         })

                         for (var i = 0; i < questObj.option.length; i++) {
                             var optionsObj = questObj.option[i];
                             if ($scope.questions[$scope.indexToShow].quesData[i].tag == optionsObj.question.tag && $scope.questions[$scope.indexToShow].optionAnswer[i].desc == optionsObj.answer.desc) {
                                 let explanation = optionsObj.explanation === undefined ? 'NA' : optionsObj.explanation
                                 $scope.errorMtf[$scope.questions[$scope.indexToShow].quesData[i].tag] = {
                                     answerType: 'Correct Answer',
                                     answerStatus: 'correct',
                                     msg: (i + 1) + ' . ' + explanation
                                 };
                                 $scope.ansExplantionMTF = i == 0 ? $scope.ansExplantionMTF = (i + 1) + ' . ' + explanation : $scope.ansExplantionMTF += ' , ' + (i + 1) + ' . ' + explanation
                             } else {
                                 let explanation = optionsObj.explanation === undefined ? 'NA' : optionsObj.explanation
                                 $scope.errorMtf[$scope.questions[$scope.indexToShow].quesData[i].tag] = {
                                     answerType: 'Wrong Answer',
                                     answerStatus: 'wrong',
                                     msg: (i + 1) + ' . ' + explanation
                                 };
                                 wrongAnsCount += 1;
                                 $scope.ansExplantionMTF = i == 0 ? $scope.ansExplantionMTF = (i + 1) + ' . ' + explanation : $scope.ansExplantionMTF += ' , ' + (i + 1) + ' . ' + explanation
                             }
                         }
                         if (wrongAnsCount == 0) {
                             $scope.accessbility = false
                             $scope.stopTimer();
                             //$scope.score+=questObj.mark.total;
                             if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {

                             } else {
                                 scoreDetails[$scope.indexToShow] = {
                                     mark: parseFloat(mark)
                                 }
                                 $scope.score += parseFloat(mark); //.total;
                             }
                             isCorrectAns = true;
                             marks.result[$scope.indexToShow] = {
                                 question_id: questObj._id,
                                 attempt_count: $scope.noOfAttempts,
                                 time_elapsed: $scope.timeData
                             }
                             $scope.ansExplantionMTF = ''
                             var index = 0
                             _.each($scope.errorMtf, function(obj, key) {
                                 if (obj.answerStatus === 'correct') {
                                     index += 1
                                     if (index === 1) {
                                         $scope.ansExplantionMTF += obj.msg
                                     } else {
                                         $scope.ansExplantionMTF += ' , ' + obj.msg
                                     }
                                 }
                             })
                         } else {
                             var index = 0
                             _.each($scope.errorMtf, function(obj, key) {
                                 if (obj.answerStatus === 'wrong') {
                                     index += 1
                                     if (index === 1) {
                                         $scope.ansExplantionMTF += obj.msg
                                     } else {
                                         $scope.ansExplantionMTF += ' , ' + obj.msg
                                     }
                                 }
                             })
                         }
                     }
                 }

                 if (isCorrectAns) {
                     $scope.resultStatus = 'Explanation'
                     $scope.totalQuestion[$scope.indexToShow].isActive = true;
                     $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     $scope.totalQuestion[$scope.indexToShow].accessbility = false
                     if (($scope.indexToShow + 1) != $scope.questions.length) {
                         $scope.actionBtnName = "Next";
                     } else {
                         marks.theme_id = $scope.selectedThemeId
                         marks.date = currentDay
                         let questionCount = $scope.totalQuestion.length
                         let answeredCount = 0
                         _.each($scope.totalQuestion, function(quest) {
                             if (quest.status === 'submit') {
                                 answeredCount++
                             }
                         })
                         if (questionCount === answeredCount) {
                             $scope.disableCntrlBtn = false;
                         } else {
                             let remainingQuestion = questionCount - answeredCount
                             toastr.success("Still you have to practice" + remainingQuestion + "question(s)")
                         }
                     }
                     $scope.noOfAttempts = 0
                 } else {
                     $scope.resultStatus = 'Hint'
                     $scope.actionBtnName = "Try Again";
                 }

             } else if ($scope.actionBtnName == "Next") {
                 //$scope.startTimer()
                 $scope.answerStatus = "normal"
                     // load next question
                 $scope.accessbility = true
                 $scope.indexToShow = ($scope.indexToShow + 1) % $scope.questions.length;
                 //$scope.isOptionSelected = false;
                 if ($scope.isPracticeTest) {

                     $scope.resetValues();
                     if ($scope.totalQuestion[$scope.indexToShow].status === 'submit') {
                         if ($scope.totalQuestion.length === $scope.indexToShow + 1) {
                             $scope.actionBtnName = "Submit"
                         } else {
                             $scope.actionBtnName = "Next"
                         }

                         $scope.accessbility = false
                         $scope.resultStatus = 'Explanation'
                         var questObj = $scope.questions[$scope.indexToShow];
                         if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                             if (questObj.pattern == "single") {
                                 angular.forEach(questObj.choice, function(value, key) {
                                     if (value.correct) {
                                         $scope.ansExplanation = value.explanation;
                                     }
                                 });
                             } else {
                                 $scope.ansExplantionMR = ""
                                 angular.forEach(questObj.choice, function(value, key) {
                                     if (value.correct) {
                                         $scope.ansExplantionMR += (key + 1) + ' . ' + value.explanation;
                                     }
                                 });
                             }
                         } else if (questObj.type == "TF") {
                             angular.forEach(questObj.choice, function(value, key) {
                                 if (value.correct) {
                                     $scope.ansExplanation = value.explanation;
                                 }
                             });
                         } else if (questObj.type == "FIB") {
                             $scope.ansExplantionFIB = ""
                             angular.forEach(questObj.answer, function(value, key) {
                                 if (value.desc != undefined) {
                                     $scope.ansExplantionFIB += (key + 1) + ' . ' + value.explanation
                                 }
                             })
                         } else if (questObj.type == "OWQ") {
                             $scope.ansExplantionOWQ = ""
                             angular.forEach(questObj.answer, function(value, key) {
                                 if (value.desc != undefined) {
                                     $scope.ansExplantionOWQ += (key + 1) + ' . ' + value.explanation
                                 }
                             })
                         } else if (questObj.type == "MTF") {
                             //for (var i = 0; i < $scope.quesData.length; i++) {
                             var optionsObj = questObj.option;
                             $scope.ansExplantionMTF = ''
                             var index = 0
                             _.each(optionsObj, function(option) {
                                 index += 1
                                 let explanation = option.explanation === undefined ? 'NA' : option.explanation
                                 if (index === 1) {
                                     $scope.ansExplantionMTF += index + ' . ' + explanation
                                 } else {
                                     $scope.ansExplantionMTF += ' , ' + index + ' . ' + explanation
                                 }
                             })
                         }
                         $scope.isOptionSelected = true
                     } else {
                         $scope.isOptionSelected = false
                     }
                 }
             } else
             if ($scope.actionBtnName == "Try Again") {
                 $scope.resetValues();
                 $scope.isOptionSelected = false
                 var questObj = $scope.questions[$scope.indexToShow];
                 if (questObj.type == "TF") {
                     var idx = $scope.selectedAns[$scope.indexToShow];
                     $scope.selectedDesc = ""
                     if (idx != undefined) {
                         $scope.selectedAns.splice($scope.indexToShow, 1);
                     }
                 } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                     var idx = $scope.ansFib[$scope.indexToShow];
                     if (idx != undefined) {
                         $scope.ansFib.splice($scope.indexToShow, 1);
                     }
                 } else if (questObj.type == "OWQ") {
                     var idx = $scope.ansOwq[$scope.indexToShow];
                     if (idx != undefined) {
                         $scope.ansOwq.splice($scope.indexToShow, 1);
                     }
                 } else if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                     if (questObj.pattern == "single") {
                         var idx = $scope.selectedAns[$scope.indexToShow];
                         $scope.selectedDesc = ""
                         if (idx != undefined) {
                             $scope.selectedAns.splice($scope.indexToShow, 1);
                         }
                     } else {
                         let emptyarry = []
                         $scope.multipleCheckAnsData[$scope.indexToShow] = emptyarry
                     }
                 }



             }

         };

         /* Practice Test Ends*/

         $scope.checkingChoiceExists = function(item) {
             let isChecked = false;
             if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
                 $scope.selectedCheckAns = $scope.multipleCheckAnsData[$scope.indexToShow]
                 return $scope.selectedCheckAns.indexOf(item) > -1
             } else {
                 return isChecked
             }
         };

         $scope.resetValues = function() {
             //Change button name for next question
             $scope.actionBtnName = "Submit";
             //Empty the answer type and explanation
             $scope.removeErrors()
         };
         $scope.removeErrors = function() {
             //Empty the answer type and explanation
             $scope.answerType = "";
             $scope.ansExplanation = "";
             //$scope.ansFib = [];
             $scope.errorFib = {};
             $scope.errorOwq = {};
             $scope.errorMtf = {};
             $scope.errorMcqQues = {};
             $scope.errorMrQues = {};
             $scope.resultStatus = ''
             $scope.selectedDesc = ''
             $scope.errorTFQues = {};
             $scope.ansExplantionMTF = ''
             $scope.ansExplantionMR = ''
             $scope.ansExplantionFIB = ''
             $scope.ansExplantionOWQ = ''
         };

         /* Invoke while clicking Prev button*/
         $scope.loadPrevQues = function() {
             $scope.evaluateQuizQuestion($scope.indexToShow);
             //To send details of each question. if student attend
             submitAnsEachQuestion(false, false);
             $scope.indexToShow = ($scope.indexToShow - 1) % $scope.totalQuestiontoShow
             $scope.isOptionSelected = false;

         }

         /* Invoke while clicking Next button*/
         $scope.loadNextQues = function() {
             $scope.$broadcast('showQuestion')
             if (($scope.indexToShow + 1) != $scope.totalQuestiontoShow) {
                 $scope.evaluateQuizQuestion($scope.indexToShow);

                 //To send details of each question. if student attend
                 submitAnsEachQuestion(false, false);

                 $scope.indexToShow = ($scope.indexToShow + 1) % $scope.totalQuestiontoShow
                 $scope.isOptionSelected = false;
             } else {
                 //To send details of last question. if student attend
                 submitAnsEachQuestion(true, false);
             }
             // $scope.startTimer()
         }

         function removeSpecialCharacter(value) {
             if (value) {
                 value = value.replace(/\\quad/g, "")
                 value = value.replace(/\\/g, "")
             }
             return value
         }

         /* Evaluate selected answer*/
         $scope.evaluateQuizQuestion = function(index) {

             let isCorrectAns = false;
             let questionMark = 0
             let selectedChoice = []
             let imageData = []
             let questObj = $scope.questions[index];

             //let mark = $scope.questionCollection[$scope.indexToShow].mark;
             let mark = $scope.questions[$scope.indexToShow].mark_each_qn;

             $scope.stopTimer();
             $scope.timeData = $scope.attendedQuesObj[$scope.indexToShow].timeElapsed + $scope.timeData


             /*START - MCQ*/
             if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                 if (questObj.pattern == "single") {
                     if ($scope.selectedAns[$scope.indexToShow] != undefined) {
                         selectedChoice.push($scope.selectedAns[$scope.indexToShow])
                         if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                             $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                         }
                     }

                     let crctAnsObj = _.find(questObj.choice, function(value) {
                         return value.correct && $scope.selectedAns[$scope.indexToShow] == value.desc
                     })

                     if (crctAnsObj != undefined) {
                         isCorrectAns = true;
                         questionMark = parseFloat(mark)
                     }
                 } else {
                     var wrongAnsCount = 0;
                     let attendedCount = 0
                     let answerChoiceLength = 0
                     let choosenCorrectCount = 0
                     let choosenWrongCount = 0
                     if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
                         let mrqObj = $scope.multipleCheckAnsData[$scope.indexToShow]
                         if (mrqObj) {
                             answerChoiceLength = mrqObj.length
                         }
                     }
                     if (answerChoiceLength > 0) {
                         attendedCount += 1
                     }
                     //get Correct answer count
                     let crctObj = _.filter(questObj.choice, function(det) {
                         return det.correct === true
                     })

                     let correctAns = '';
                     let choices = [];
                     for (var i = crctObj.length - 1; i >= 0; i--) {
                         correctAns += crctObj[i].desc + "[,]"
                     }

                     _.each(questObj.choice, function(choice) {
                         choices.push({
                             name: choice.desc,
                             "description": {
                                 "en-US": choice.hint
                             }
                         })
                     })

                     let correcrAnswerCount = (crctObj) ? crctObj.length : 0
                     if (answerChoiceLength === questObj.choice.length) {
                         questionMark = 0
                         _.each(questObj.choice, function(choice) {
                             if (choice.correct) {
                                 if ($scope.checkingChoiceExists(choice.desc)) {
                                     //CASE : Correct Ans
                                     selectedChoice.push(choice.desc)
                                     choosenCorrectCount += 1
                                 } else {
                                     wrongAnsCount += 1;
                                 }
                             } else if ($scope.checkingChoiceExists(choice.desc)) {
                                 wrongAnsCount += 1;
                                 selectedChoice.push(choice.desc)
                                 choosenWrongCount += 1
                             }
                         })
                     } else {
                         _.each(questObj.choice, function(choice) {
                             if (choice.correct) {
                                 if ($scope.checkingChoiceExists(choice.desc)) {
                                     //CASE : Correct Ans
                                     selectedChoice.push(choice.desc)
                                     choosenCorrectCount += 1
                                 } else {
                                     wrongAnsCount += 1;
                                 }
                             } else if ($scope.checkingChoiceExists(choice.desc)) {
                                 wrongAnsCount += 1;
                                 selectedChoice.push(choice.desc)
                                 choosenWrongCount += 1
                             }
                         })
                         if (correcrAnswerCount === choosenCorrectCount && choosenWrongCount === 0) {
                             questionMark = parseFloat(mark)
                         } else {
                             if (choosenCorrectCount >= choosenWrongCount && choosenCorrectCount > 0 && choosenWrongCount > 0) {
                                 questionMark = parseFloat(parseFloat(mark) / 2)
                             } else if (choosenCorrectCount > 0 && choosenWrongCount === 0 && choosenCorrectCount >= Math.round(correcrAnswerCount / 2)) {
                                 questionMark = parseFloat(parseFloat(mark) / 2)
                             }
                         }
                         if (wrongAnsCount == 0) {
                             isCorrectAns = true;
                             questionMark = parseFloat(mark)
                         }
                     }
                 }
             }
             /*END - MCQ*/

             /* START - TF*/
             else if (questObj.type == "TF") {
                 var keepGoing = false;
                 let correctAns = false;
                 if ($scope.selectedAns[$scope.indexToShow] != undefined) {
                     selectedChoice.push($scope.selectedAns[$scope.indexToShow])
                 }

                 let tfAnsObj = _.find(questObj.choice, function(value) {
                     return value.correct && $scope.selectedAns[$scope.indexToShow] == value.tag
                 })

                 if (tfAnsObj != undefined) {
                     isCorrectAns = true;
                     keepGoing = true;
                     questionMark = parseFloat(mark)
                 }
             }
             /*END - TF*/

             /*START - FIB*/
             else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                 if (questObj.answerImg)
                     imageData.push(questObj.answerImg)
                 var fibAnswerCount = questObj.question_answer != undefined ? questObj.question_answer.length : 0;
                 var wrongAnsCount = 0;
                 let attendedCount = 0
                 if (questObj.question_answer) {
                     _.each(questObj.question_answer, function(value, key) {
                         if (value != undefined && value.desc != undefined) {
                             if ($scope.ansFib.length > 0) {
                                 if ($scope.ansFib[$scope.indexToShow] == undefined || $scope.ansFib[$scope.indexToShow].choice[key] == "" || $scope.ansFib[$scope.indexToShow].choice[key] == undefined) {
                                     wrongAnsCount += 1;
                                     selectedChoice.push(undefined)
                                         //$scope.stopTimer();
                                         //Case : User doesnt't write
                                 } else {
                                     attendedCount += 1
                                         /*let correctValue = removeSpecialCharacter(value.desc)
                                         let studentAnswer = removeSpecialCharacter($scope.ansFib[$scope.indexToShow].choice[key])
                                         */
                                     let correctValue = value.desc
                                     let studentAnswer = $scope.ansFib[$scope.indexToShow].choice[key]
                                     if (correctValue.toLowerCase().trim() == studentAnswer.toLowerCase().trim()) {
                                         //Case :  Correct Answer
                                         //$scope.stopTimer();                                    
                                         selectedChoice.push($scope.ansFib[$scope.indexToShow].choice[key])
                                     } else {
                                         //Case :  Wrong Answer
                                         wrongAnsCount += 1;
                                         selectedChoice.push($scope.ansFib[$scope.indexToShow].choice[key])
                                     }

                                 }
                             } else {
                                 wrongAnsCount += 1;
                                 selectedChoice.push(undefined)
                             }
                         }
                     })
                 }

                 if (wrongAnsCount == 0) {
                     isCorrectAns = true;
                     questionMark = parseFloat(mark)
                 }

                 /* $scope.stopTimer();*/
             }
             /*END - FIB*/

             /*START - OWQ*/
             else if (questObj.type == "OWQ") {
                 var owqAnswerCount = questObj.question_answer != undefined ? questObj.question_answer.length : 0;
                 var wrongAnsCount = 0;
                 let attendedCount = 0
                 if (questObj.answerImg)
                     imageData.push(questObj.answerImg)
                 if (questObj.question_answer) {

                     _.each(questObj.question_answer, function(value, key) {
                         if (value != undefined && value.desc != undefined) {
                             if ($scope.ansOwq.length > 0) {
                                 if ($scope.ansOwq[$scope.indexToShow] == undefined || $scope.ansOwq[$scope.indexToShow] == "" || $scope.ansOwq[$scope.indexToShow] == undefined) {
                                     wrongAnsCount += 1;
                                     selectedChoice.push(undefined)
                                         //$scope.stopTimer();
                                         //Case : User doesnt't write
                                 } else {
                                     attendedCount += 1
                                     let correctValue = value.desc
                                     let studentValue = $scope.ansOwq[$scope.indexToShow]
                                     if (correctValue.toLowerCase().trim() == studentValue.toLowerCase().trim()) {
                                         //Case :  Correct Answer
                                         //$scope.stopTimer();
                                         selectedChoice.push($scope.ansOwq[$scope.indexToShow])
                                     } else {
                                         //Case :  Wrong Answer
                                         wrongAnsCount += 1;
                                         selectedChoice.push($scope.ansOwq[$scope.indexToShow])
                                     }
                                 }
                             } else {
                                 wrongAnsCount += 1;
                                 selectedChoice.push(undefined)
                             }
                         }
                     })
                 }

                 if (wrongAnsCount == 0) {
                     isCorrectAns = true;
                     questionMark = parseFloat(mark)
                 }
                 /* $scope.stopTimer();*/
             }
             /*END - OWQ*/

             /*START - MTF*/
             else if (questObj.type == "MTF") {
                 if ($scope.isOptionSelected == true) {
                     let eachOptMark = parseFloat(mark / questObj.optionAnswer.length)
                     var wrongAnsCount = 0;
                     let crctAnsCount = 0
                     for (var i = 0; i < questObj.optionAnswer.length; i++) {

                         var optionsObj = questObj.option[i];

                         if (questObj.optionAnswer[i].tag == optionsObj.answer.tag) {
                             crctAnsCount++;
                             let desc = questObj.optionAnswer[i].desc !== undefined ? optionsObj.answer.desc : undefined
                             let mtfAnsObj = {
                                 "desc": desc,
                                 "optImage": optionsObj.answer.optImage
                             }
                             selectedChoice.push(mtfAnsObj)
                         } else {
                             //Case : Wrong Answer
                             wrongAnsCount += 1;
                             let mtfAnsObj = {
                                 "desc": questObj.optionAnswer[i].desc,
                                 "optImage": questObj.optionAnswer[i].optImage
                             }
                             selectedChoice.push(mtfAnsObj)
                         }
                     }


                     //questionMark = parseFloat(eachOptMark * crctAnsCount) 
                     if (wrongAnsCount == 0) {

                         isCorrectAns = true;
                     } else {
                         isCorrectAns = false;
                     }

                     let correctans = ''
                     let source = []
                     let target = []

                     for (var i = 0; i < questObj.length; i++) {
                         var optionsObj = questObj.option[i];

                         correctans += optionsObj.question.desc + "[.]" + optionsObj.answer.desc + "[,]"

                         source.push({
                             "id": optionsObj.question.desc,
                             "description": {
                                 "en-US": optionsObj.question.desc
                             }
                         })

                         target.push({
                             "id": optionsObj.answer.desc,
                             "description": {
                                 "en-US": optionsObj.answer.desc
                             }
                         })

                     }

                 }

                 let isAttend = false

                 if (questObj.answer && questObj.answer.length > 0) {
                     isAttend = true
                     if (selectedChoice.length == 0) {
                         selectedChoice = questObj.answer
                     }
                 } else if ($scope.attendedQuesObj[$scope.indexToShow] && $scope.attendedQuesObj[$scope.indexToShow].answer &&
                     $scope.attendedQuesObj[$scope.indexToShow].answer.length > 0) {
                     isAttend = true
                         //console.log(selectedChoice) 
                     selectedChoice = $scope.attendedQuesObj[$scope.indexToShow].answer
                 } else {
                     isAttend = $scope.isOptionSelected
                 }

                 let obj = {
                     questionId: questObj.question_id,
                     mark: 0,
                     timeElapsed: $scope.timeData,
                     q_type: questObj.type,
                     answer: selectedChoice,
                     section_name: questObj.section_name,
                     is_attended: isAttend
                 }
                 $scope.attendedQuesObj[$scope.indexToShow] = obj


                 //console.log($scope.totalQuestion[$scope.indexToShow].label)

                 if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && isAttend) {
                     $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                 } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                     $scope.totalQuestion[$scope.indexToShow].status = 'review';
                 } else {
                     $scope.totalQuestion[$scope.indexToShow].status = 'normal';
                 }


                 /* $scope.stopTimer();*/
             }
             /*END - MTF*/

             /*START - SA*/
             else if (questObj.type == "SA" || questObj.type == "LA") {
                 isCorrectAns = true;
                 questionMark = parseFloat(mark); //.total;
             }
             /*END - SA*/


             if (questObj.type == "SA") {
                 let isAttend = false
                 if ($scope.ansSa[$scope.indexToShow] || $scope.imageData[$scope.indexToShow]) {
                     if (_.compact($scope.ansSa[$scope.indexToShow]).length > 0 || $scope.imageData[$scope.indexToShow].length > 0) {
                         $scope.attendedQuesObj[$scope.indexToShow] = {
                             questionId: questObj.question_id,
                             mark: 0,
                             timeElapsed: $scope.timeData,
                             q_type: questObj.type,
                             imageData: $scope.imageData[$scope.indexToShow],
                             answer: $scope.ansSa[$scope.indexToShow],
                             section_name: questObj.section_name,
                             is_attended: true
                         }
                         isAttend = true
                             /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                                 $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                             } */

                         //$scope.attendedQuesObj[$scope.indexToShow] = obj
                      } else {
                         $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = []
                         $scope.attendedQuesObj[$scope.indexToShow]["answer"] = []
                         $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false
                             //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                     }
                 } else {
                     $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = []
                     $scope.attendedQuesObj[$scope.indexToShow]["answer"] = []
                     $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false
                         //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                 }


                 if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && isAttend) {
                     $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                 } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                     $scope.totalQuestion[$scope.indexToShow].status = 'review';
                 } else {
                     $scope.totalQuestion[$scope.indexToShow].status = 'normal';
                 }


                 /*if ($scope.imageData[$scope.indexToShow] != undefined || questObj.answer != undefined) {
                  if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                  $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                  }
                  }*/

             } else if (questObj.type == "LA") {
                 let isAttend = false
                 if ($scope.ansLa[$scope.indexToShow] || $scope.imageData[$scope.indexToShow]) {
                     if (_.compact($scope.ansLa[$scope.indexToShow]).length > 0 || $scope.imageData[$scope.indexToShow].length > 0) {
                         $scope.attendedQuesObj[$scope.indexToShow] = {
                             questionId: questObj.question_id,
                             mark: 0,
                             timeElapsed: $scope.timeData,
                             q_type: questObj.type,
                             imageData: $scope.imageData[$scope.indexToShow],
                             answer: $scope.ansLa[$scope.indexToShow],
                             section_name: questObj.section_name,
                             is_attended: true

                         }
                         isAttend = true
                             /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                                 $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                             } */

                         //$scope.attendedQuesObj[$scope.indexToShow] = obj
                     } else {
                         $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = []
                         $scope.attendedQuesObj[$scope.indexToShow]["answer"] = []
                         $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false
                             //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                     }
                 } else {
                     $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = []
                     $scope.attendedQuesObj[$scope.indexToShow]["answer"] = []
                     $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false
                         //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                 }


                 if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && isAttend) {
                     $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                 } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                     $scope.totalQuestion[$scope.indexToShow].status = 'review';
                 } else {
                     $scope.totalQuestion[$scope.indexToShow].status = 'normal';
                 }

                 /*if ($scope.imageData[$scope.indexToShow] != undefined || questObj.answer != undefined) {
                  if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                  $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                  }
                  }*/

             } else if (questObj.type == "DRAW") {
                 if (questObj.answerImg !== undefined) {


                     $scope.attendedQuesObj[$scope.indexToShow] = {
                         questionId: questObj.question_id,
                         mark: 0,
                         timeElapsed: $scope.timeData,
                         q_type: questObj.type,
                         /* images: $scope.imageData[$scope.indexToShow],*/
                         answer: $scope.ansDraw[$scope.indexToShow],
                         answerImg: questObj.answerImg,
                         section_name: questObj.section_name,
                         is_attended: $scope.isOptionSelected
                     }
                     if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                         $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     }
                 }
             } else if (questObj.type == "ASLLISTEN") {
                 if (_.compact(_.flatten(_.pluck($scope.ansAslListen[$scope.indexToShow].ans, 'answer'))).length > 0) {
                     $scope.attendedQuesObj[$scope.indexToShow] = {
                         questionId: questObj.question_id,
                         mark: 0,
                         timeElapsed: $scope.timeData,
                         q_type: questObj.type,
                         answer: $scope.ansAslListen[$scope.indexToShow].ans,
                         section_name: questObj.section_name,
                         is_attended: $scope.isOptionSelected
                     }
                     if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                         $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     }
                 }
             } else if (questObj.type == "ASLSPEAK") {
                 if ($scope.ansAslSpeak[$scope.indexToShow].answer != '') {

                     $scope.attendedQuesObj[$scope.indexToShow] = {
                         questionId: questObj.question_id,
                         mark: 0,
                         timeElapsed: $scope.timeData,
                         q_type: questObj.type,
                         answer: $scope.ansAslSpeak[$scope.indexToShow].answer,
                         section_name: questObj.section_name,
                         is_attended: $scope.isOptionSelected
                     }
                     if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                         $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     }
                 }
             } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB" || questObj.type == "OWQ") {
                 let isAttend = false
                 if (selectedChoice || $scope.imageData[$scope.indexToShow]) {

                     //console.log(_.compact(selectedChoice))
                     //console.log(selectedChoice)
                     //console.log($scope.imageData[$scope.indexToShow])

                     let ansData = _.compact(selectedChoice)
                     let imgData = $scope.imageData[$scope.indexToShow]

                     if ((ansData && ansData.length > 0) || (imgData && imgData.length > 0)) {
                         let obj = {
                             questionId: questObj.question_id,
                             mark: 0,
                             timeElapsed: $scope.timeData,
                             q_type: questObj.type,
                             imageData: $scope.imageData[$scope.indexToShow],
                             answer: selectedChoice,
                             section_name: questObj.section_name,
                             is_attended: true

                         }
                         isAttend = true
                             /*  if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                                  $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                              } */
                         $scope.attendedQuesObj[$scope.indexToShow] = obj
                     } else {
                         $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = []
                         $scope.attendedQuesObj[$scope.indexToShow]["answer"] = []
                         $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false
                             //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                     }
                 }

                 if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && isAttend) {
                     $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                 } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                     $scope.totalQuestion[$scope.indexToShow].status = 'review';
                 } else {
                     $scope.totalQuestion[$scope.indexToShow].status = 'normal';
                 }

             } else if (questObj.type != "MTF") {

                 let isAttend = false
                 let mark = 0
                 let ansData = _.compact(selectedChoice)
                 if (ansData && ansData.length > 0) {
                     if (questObj.type !== 'MTF') {
                         mark = questionMark.toFixed(2)
                     }
                     /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                         $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     } */
                 }

                 /* console.log("==========================")
                console.log(ansData)
                console.log($scope.multipleCheckAnsData)
                console.log(questObj.answer)
    
                console.log("==========================") */

                 let obj = {
                     questionId: questObj.question_id,
                     mark: mark,
                     timeElapsed: $scope.timeData,
                     q_type: questObj.type,
                     answer: selectedChoice,
                     section_name: questObj.section_name,
                     is_attended: (ansData && ansData.length > 0) ? true : false
                 }

                 isAttend = (ansData && ansData.length > 0) ? true : false
                 $scope.attendedQuesObj[$scope.indexToShow] = obj
                     //$scope.attendedQuesObj[$scope.indexToShow]['is_attended'] = $scope.isOptionSelected

                 if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && isAttend) {
                     $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                 } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                     $scope.totalQuestion[$scope.indexToShow].status = 'review';
                 } else {
                     $scope.totalQuestion[$scope.indexToShow].status = 'normal';
                 }

             }

             /*  else {
                 if (_.compact(selectedChoice).length > 0) {
                     let mark = 0
                     if (questObj.type !== 'MTF')
                         mark = questionMark.toFixed(2)
                     $scope.attendedQuesObj[$scope.indexToShow] = {
                         questionId: questObj.question_id,
                         mark: mark,
                         timeElapsed: $scope.timeData,
                         q_type: questObj.type,
                         answer: selectedChoice,
                         section_name: questObj.section_name,
                         is_attended: $scope.isOptionSelected,
                         imageData: imageData
                     }
                     if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                         $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     }
                 } else
                     $scope.attendedQuesObj[$scope.indexToShow]['is_attended'] = $scope.isOptionSelected
             } */
         }


         /* Set selected answer for evaluation */
         $scope.setSelectedAns = function(option, quesType, ansType, index) {
             if ($scope.actionBtnName === "Try Again") {
                 $scope.actionBtnName = "Submit"

                 $scope.resetValues();
                 $scope.isOptionSelected = false
                 var questObj = $scope.questions[$scope.indexToShow];
                 if (questObj.type == "TF") {
                     var idx = $scope.selectedAns[$scope.indexToShow];
                     $scope.selectedDesc = ""
                     if (idx != undefined) {
                         $scope.selectedAns.splice($scope.indexToShow, 1);
                     }
                 } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                     var idx = $scope.ansFib[$scope.indexToShow];
                     if (idx != undefined) {
                         $scope.ansFib.splice($scope.indexToShow, 1);
                     }
                 } else if (questObj.type == "OWQ") {
                     var idx = $scope.ansOwq[$scope.indexToShow];
                     if (idx != undefined) {
                         $scope.ansOwq.splice($scope.indexToShow, 1);
                     }
                 } else if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                     if (questObj.pattern == "single") {
                         var idx = $scope.selectedAns[$scope.indexToShow];
                         $scope.selectedDesc = ""
                         if (idx != undefined) {
                             $scope.selectedAns.splice($scope.indexToShow, 1);
                         }
                     } else {

                         let emptyarry = []
                         $scope.multipleCheckAnsData[$scope.indexToShow] = emptyarry
                     }
                 }
             }

             if (quesType == "MCQ" || quesType == "TF") {
                 $scope.isOptionSelected = true;
                 $scope.selectedDesc = option
                 $scope.selectedAns[$scope.indexToShow] = option;
             } else if (quesType == "MR") {
                 $scope.isOptionSelected = true;
                 $scope.selectedCheckAns = []
                 if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
                     $scope.selectedCheckAns = $scope.multipleCheckAnsData[$scope.indexToShow]
                     var idx = $scope.selectedCheckAns.indexOf(option);
                     if (idx > -1) {
                         $scope.selectedCheckAns.splice(idx, 1);
                     } else {
                         $scope.selectedCheckAns.push(option);
                     }
                 } else {
                     $scope.selectedCheckAns.push(option);
                 }
                 $scope.multipleCheckAnsData[$scope.indexToShow] = $scope.selectedCheckAns;
             } else if (quesType == "FIB") {
                 if ($scope.ansFib[$scope.indexToShow] != undefined) {
                     $scope.isOptionSelected = true;
                 }
             } else if (quesType == "OWQ") {
                 if ($scope.ansOwq[$scope.indexToShow] != undefined) {
                     $scope.isOptionSelected = true;
                 }
             } else if (quesType == "ASLLISTEN") {
                 if (ansType == "MCQ" || ansType == "TF") {
                     $scope.ansAslListen[$scope.indexToShow].ans[index].answer = option;
                 } else if (ansType == "MR") {
                     $scope.selectedCheckAns = []
                     if ($scope.ansAslListen[$scope.indexToShow].ans[index].answer[$scope.indexToShow] != undefined) {
                         $scope.selectedCheckAns = $scope.ansAslListen[$scope.indexToShow].ans[index].answer
                         var idx = $scope.selectedCheckAns.indexOf(option);
                         if (idx > -1) {
                             $scope.selectedCheckAns.splice(idx, 1);
                         } else {
                             $scope.selectedCheckAns.push(option);
                         }
                     } else {
                         $scope.selectedCheckAns.push(option);
                     }
                     $scope.ansAslListen[$scope.indexToShow].ans[index].answer = $scope.selectedCheckAns;
                 }
             }
         };

         let quizMarks = {
             'student_id': userId,
             'date': currentDay,
             'time_elapsed': $scope.elapsedTime,
             'score': 0,
             'total_mark': 0,
             'activity_id': activityId,
             'qp_id': qpId,
             'result': []
         }

         /* Invoke while submitting last question */
         $scope.submitQuizQuestion = function() {
             $scope.stopTimer();
             $scope.evaluateQuizQuestion($scope.indexToShow);
             let isReviewedQuestionCount = 0
             _.each($scope.totalQuestion, function(question, key) {
                 if (question.status == 'review') {
                     isReviewedQuestionCount++
                 }
             })
             if (isReviewedQuestionCount == 0) {
                 var confirm = $mdDialog.confirm()
                     .title('Do you want to submit the exam?')
                     .targetEvent(event)
                     .ariaLabel('Information')
                     .ok('YES')
                     .cancel('NO');
                 $mdDialog.show(confirm).then(function() {
                     $scope.submitExam()
                 }, function() {
                     //toastr.success("You decided to continue the exam")
                 });
             } else {
                 var confirm = $mdDialog.confirm()
                     .title('You have marked ' + isReviewedQuestionCount + ' question(s) for Review, still you want to submit the exam')
                     .targetEvent(event)
                     .ariaLabel('Review Alert')
                     .ok('YES')
                     .cancel('NO');
                 $mdDialog.show(confirm).then(function() {
                     $scope.submitExam()
                 }, function() {
                     toastr.success("You decided to continue the exam")
                         // ToastService.getToastbox($mdToast, 'You decided to continue the exam', 'success-toast')
                         //'You decided to keep your entry.';
                 });
             }
         }

         /* Submit exam data to server */
         $scope.submitExam = function() {
             $scope.isSubmitted = true
             localStorage.removeItem("backfromexam");
             localStorage.setItem('activitySubmitted', true)
             let finalScore = 0
             let timeSpent = 0



             for (var i = 0; i < $scope.attendedQuesObj.length; i++) {
                 if ($scope.attendedQuesObj[i] != undefined) {

                     //Get Spent Time
                     timeSpent += parseInt($scope.attendedQuesObj[i].timeElapsed)

                     finalScore += parseFloat($scope.attendedQuesObj[i].mark)
                     if ($scope.attendedQuesObj[i].q_type == "SA" || $scope.attendedQuesObj[i].q_type == "LA") {

                         if ($scope.attendedQuesObj[i].images != undefined) {
                             _.each($scope.attendedQuesObj[i].images.images, function(imgs) {
                                 delete imgs.$$hashKey
                             })
                         }

                         quizMarks.result.push({
                             question_id: $scope.attendedQuesObj[i].questionId,
                             mark: $scope.attendedQuesObj[i].mark,
                             time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                             q_type: $scope.attendedQuesObj[i].q_type,
                             answerImg: $scope.attendedQuesObj[i].imageData,
                             answer: $scope.attendedQuesObj[i].answer ? $scope.attendedQuesObj[i].answer : "",
                             section_name: $scope.attendedQuesObj[i].section_name,
                             is_attended: $scope.attendedQuesObj[i].is_attended
                         })

                     } else if ($scope.attendedQuesObj[i].q_type == "DRAW") {
                         quizMarks.result.push({
                             question_id: $scope.attendedQuesObj[i].questionId,
                             mark: $scope.attendedQuesObj[i].mark,
                             time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                             q_type: $scope.attendedQuesObj[i].q_type,
                             answer: $scope.attendedQuesObj[i].answer,
                             answerImg: $scope.attendedQuesObj[i].answerImg,
                             section_name: $scope.attendedQuesObj[i].section_name,
                             is_attended: $scope.attendedQuesObj[i].is_attended
                         })
                     } else {
                         quizMarks.result.push({
                             question_id: $scope.attendedQuesObj[i].questionId,
                             mark: $scope.attendedQuesObj[i].mark,
                             time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                             q_type: $scope.attendedQuesObj[i].q_type,
                             answer: $scope.attendedQuesObj[i].answer,
                             section_name: $scope.attendedQuesObj[i].section_name,
                             is_attended: $scope.attendedQuesObj[i].is_attended
                         })
                     }

                 }
             }
             quizMarks.time_elapsed = $scope.elapsedTime
             quizMarks.score = finalScore; //.toFixed(2)
             quizMarks.total_mark = $scope.quizTotalMark
             quizMarks.activity_id = activityId
             quizMarks.qp_id = qpId
             quizMarks.time_spent = timeSpent

             if ($scope.totalTimeRemaining)
                 quizMarks.totalTimeRemaining = $scope.totalTimeRemaining
             $scope.isPracticeTest = false
             $scope.isActivity = false
         }

         /*
          * To submit attended question to server
          * 
          * @isLstQues : Boolean - Last question check
          * @isAutoSubmit : Boolean - Auto submission check
          * @return : null
          * @Developer : Jeevanantham N
          */
         let submitAnsEachQuestion = (isLstQues, isAutoSubmit) => {
             if ($scope.attendedQuesObj.length && $scope.attendedQuesObj[$scope.indexToShow]) {
                 let resultObj = {}
                 let ansObj = $scope.attendedQuesObj[$scope.indexToShow]
                 if ((ansObj && ansObj.questionId != undefined) || (isLstQues && !isAutoSubmit)) {
                     let timeSpent = 0
                     _.each($scope.attendedQuesObj, function(data) {
                         if (data && data.timeElapsed) {
                             timeSpent += parseInt(data.timeElapsed)
                         }
                     })

                     resultObj = {
                             question_id: ansObj.questionId,
                             mark: ansObj.mark,
                             time_elapsed: ansObj.timeElapsed,
                             q_type: ansObj.q_type,
                             answerImg: "",
                             answer: "",
                             q_status: $scope.totalQuestion[$scope.indexToShow].status,
                             section_name: ansObj.section_name,
                             is_attended: ansObj.is_attended != undefined ? ansObj.is_attended : false,
                             //question_index: $scope.indexToShow
                         }
                         //If theer is no answer while submitting last question
                     if (isLstQues && resultObj.question_id == undefined) {
                         let questObj = $scope.questions[$scope.indexToShow]
                         resultObj.question_id = questObj.question_id
                         resultObj.q_type = questObj.type
                     }


                     if (ansObj.q_type == "SA" || ansObj.q_type == "LA" || ansObj.q_type == "OWQ" || ansObj.q_type == "FIB" || ansObj.q_type == "MTF") {
                         if (ansObj.images != undefined) {
                             _.each(ansObj.images.images, function(imgs) {
                                 delete imgs.$$hashKey
                             })
                         }
                         resultObj.answerImg = ansObj.imageData
                         resultObj.answer = ansObj.answer ? ansObj.answer : ""
                     } else if (ansObj.q_type == "DRAW") {
                         resultObj.answer = ansObj.answer
                         resultObj.answerImg = ansObj.answerImg
                     } else {
                         resultObj.answer = ansObj.answer
                     }

                     let requestObj = {}

                     //activity_id:, student_id:
                     /* requestObj["activity_id"] = "KDqybKrnxrC44";
                     requestObj["qp_id"] = "Gn4JwyXBAMtp9JZ2c";
                     requestObj["student_id"] = "7vprkAsiMgMRESaf9"; */



                     requestObj["activity_id"] = activityId
                     requestObj["time_spent"] = timeSpent
                     requestObj["qp_id"] = qpId
                     requestObj["student_id"] = userId
                     requestObj["total_mark"] = totalMark
                     requestObj["result"] = resultObj

                     if (isLstQues && !isAutoSubmit) {

                         let isReviewedQuestionCount = 0
                         isReviewedQuestionCount = _.filter($scope.totalQuestion, (dta) => {
                             return dta.status == 'review'
                         }).length

                         //console.log(isReviewedQuestionCount)

                         let msg = 'Do you want to submit the exam?'
                         if (isReviewedQuestionCount > 0) {
                             msg = 'You have marked ' + isReviewedQuestionCount + ' question(s) for Review, still you want to submit the exam'
                         }

                         var confirm = $mdDialog.confirm()
                             .title(msg)
                             .targetEvent(event)
                             .ariaLabel('Information')
                             .ok('YES')
                             .cancel('NO');
                         $mdDialog.show(confirm).then(function() {
                             submitAnswer(requestObj, true);
                         }, function() {
                         });
                     } else {
                         submitAnswer(requestObj, false);
                     }
                 }

             }
         }

         let submitAnswer = (requestObj, isBack) => {
             authService.callAPI(activityCons.API_SUBMIT_EXAM_QUESTION, "POST", requestObj, function(response) {
                 if (response.result != undefined) {
                     if (isBack) {
                         stopExam(requestObj)
                     }
                 } else {
                     //console.log(response)
                     if (response.error && response.error.error && response.error.error.status === "completedExam") {
                         toastr.success("Exam is over")
                         stopExam(requestObj);
                     }
                 }
             })
         }

         let stopExam = (requestObj) => {
             let res = _.pick(requestObj, "student_id", "qp_id", "activity_id")
             authService.callAPI(activityCons.API_SUBMIT_EXAM, "POST", res, function(response) {
                 if (response.result != undefined) {
                     clearTimer()
                     toastr.success("Your answer is submitted successfully")
                     $state.go('activityFormPreview', {
                         resourceId: activityId
                     }, {
                         reload: true
                     })
                 } else {

                 }
             })
         }

         $scope.submitLastQuestion = (isLstQues, isAutoSubmit) => {
             $scope.evaluateQuizQuestion($scope.indexToShow);
             submitAnsEachQuestion(isLstQues, isAutoSubmit)
         }


         /*
          * Function to cancel timer
          */
         $scope.$on("$destroy", function() {
             if (angular.isDefined(timeinterval)) {
                 $interval.cancel(timeinterval);
             }
         });

     }
 }
 export default QuestionDirective


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/activity/questionDirective.js